import React, { useMemo } from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import { status as pageStatus } from 'context/EditorContext'
import { themeType } from 'types'
import { withTheme } from 'styled-components'

const {
  edited, local, published, none, prePublished
} = pageStatus

const StatusCircle = ({ status, theme }) => {
  const color = useMemo(() => {
    if (status === edited || status === local) return theme.colors.yellow
    if (status === published) return theme.colors.green
    if (status === prePublished) return theme.colors.blueLight
    if (status === none) return theme.colors.red
    return theme.colors.bgDarker
  }, [status, theme])
  return (
    <Circle color={color} />
  )
}

const Circle = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: ${props => props.color || props.theme.color.bgLighterS};
`


StatusCircle.propTypes = {
  status: PropTypes.oneOf([...Object.keys(pageStatus), 'history', 'actual']).isRequired,
  theme: themeType.isRequired,
}

export default withTheme(StatusCircle)
